import { useState, useEffect } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarController,
  Chart,
  BarElement,
  Legend,
  Title,
  Tooltip,
  LogarithmicScale,
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Bar } from 'react-chartjs-2'
import { Button, Grid } from '@mui/material'
import { styled } from '@mui/system'
import { useTheme } from '@mui/material/styles'

import { getChartData } from '../utils/financialChartData'
import {
  createFinancialDataRow,
  compareArrayForOptions,
} from '../utils/financialChartLogic'
import { chartOptions } from '../utils/financialChartParameters'

Chart.register(
  CategoryScale,
  LinearScale,
  BarController,
  BarElement,
  Legend,
  Title,
  Tooltip,
  ChartDataLabels,
  LogarithmicScale
)

const StyledButton = styled(Button)({
  marginBottom: '20px',
  marginLeft: '65px',
  marginTop: '-40px',
  backgroundColor: '#ca8c00',
  color: 'white',
  lineHeight: '14px',
  '&:hover': {
    backgroundColor: '#ca8c55',
    color: 'white',
  },
})

function FinancialDataBarChart({ financialData }) {
  const barThickness = 38
  const defaultChartSize = 400

  const theme = useTheme()
  const budgetColor = '#6597b1' // Not a color globaly defined
  const realizedColor = theme.palette.primary.main // Not a color globaly defined
  const lastYearRealizedColor = '#ca8c00'

  const [showLastYearRealized, setShowLastYearRealized] = useState(true)
  const [financialDataRow, setFinancialDataRow] = useState({})
  const [chartHeight, setChartHeight] = useState(defaultChartSize)

  useEffect(() => {
    if (financialData) {
      const newFinancialData = createFinancialDataRow(financialData)

      setFinancialDataRow(newFinancialData)

      const numberOfBars = newFinancialData.name?.length || 0
      // x2 for the padding beetween bars + 25 at the end for the menu size
      const calculatedHeight = numberOfBars * (barThickness * 2) + 25
      setChartHeight(calculatedHeight)
    }
  }, [financialData])

  const toggleLastYearRealized = () => {
    setShowLastYearRealized(!showLastYearRealized)
  }

  const data = getChartData(
    financialDataRow,
    barThickness,
    budgetColor,
    realizedColor,
    lastYearRealizedColor,
    showLastYearRealized,
    compareArrayForOptions
  )

  const options = chartOptions(financialDataRow)

  return (
    <Grid>
      <Grid
        sx={{
          width: '100%',
          minHeight: defaultChartSize,
          // Set dynamicaly the size depending on the number of rows
          height: chartHeight,
        }}
      >
        <Bar data={data} options={options} />
      </Grid>
      <StyledButton variant="contained" onClick={toggleLastYearRealized}>
        {showLastYearRealized
          ? 'Cacher Graphe Réalisé N-1'
          : 'Afficher Graphe Réalisé N-1'}
      </StyledButton>
    </Grid>
  )
}

export default FinancialDataBarChart
